import { useEffect } from 'react';

/**
 * Calls `onOutside` when a mousedown happens outside every passed ref.
 * Pass one or multiple refs (e.g. trigger button + portal menu) to keep
 * the popover open while clicking on any of them.
 *
 * @param {Array<{current: HTMLElement|null}>|{current: HTMLElement|null}} refs
 * @param {() => void} onOutside
 * @param {boolean} [enabled=true] - listener is only attached when truthy
 */
export function useOutsideClick(refs, onOutside, enabled = true) {
	useEffect(() => {
		if (!enabled) return undefined;
		const refList = Array.isArray(refs) ? refs : [refs];
		const handler = (event) => {
			for (const ref of refList) {
				if (ref?.current?.contains(event.target)) return;
			}
			onOutside();
		};
		document.addEventListener('mousedown', handler);
		return () => document.removeEventListener('mousedown', handler);
	}, [refs, onOutside, enabled]);
}
